import { createI18n } from 'vue-i18n';
import {
    applyDocumentLang,
    bindVuetify,
    getSavedLocale,
    isSupportedLocale,
    persistLocale,
    syncVuetifyLocale,
} from './locale';

import ptCommon from './locales/pt/common.json';
import ptAuth from './locales/pt/auth.json';
import ptSidebar from './locales/pt/sidebar.json';
import ptToolbar from './locales/pt/toolbar.json';
import ptAdmin from './locales/pt/admin.json';
import ptStudent from './locales/pt/student.json';
import ptCorporate from './locales/pt/corporate.json';
import ptCourseGroups from './locales/pt/courseGroups.json';
import ptGroupAssignments from './locales/pt/groupAssignments.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enSidebar from './locales/en/sidebar.json';
import enToolbar from './locales/en/toolbar.json';
import enAdmin from './locales/en/admin.json';
import enStudent from './locales/en/student.json';
import enCorporate from './locales/en/corporate.json';
import enCourseGroups from './locales/en/courseGroups.json';
import enGroupAssignments from './locales/en/groupAssignments.json';

import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esSidebar from './locales/es/sidebar.json';
import esToolbar from './locales/es/toolbar.json';
import esAdmin from './locales/es/admin.json';
import esStudent from './locales/es/student.json';
import esCorporate from './locales/es/corporate.json';
import esCourseGroups from './locales/es/courseGroups.json';
import esGroupAssignments from './locales/es/groupAssignments.json';

function buildMessages(parts) {
    return {
        common: parts.common,
        auth: parts.auth,
        sidebar: parts.sidebar,
        toolbar: parts.toolbar,
        admin: parts.admin,
        student: parts.student,
        corporate: parts.corporate,
        courseGroups: parts.courseGroups,
        groupAssignments: parts.groupAssignments,
    };
}

const messages = {
    pt: buildMessages({
        common: ptCommon,
        auth: ptAuth,
        sidebar: ptSidebar,
        toolbar: ptToolbar,
        admin: ptAdmin,
        student: ptStudent,
        corporate: ptCorporate,
        courseGroups: ptCourseGroups,
        groupAssignments: ptGroupAssignments,
    }),
    en: buildMessages({
        common: enCommon,
        auth: enAuth,
        sidebar: enSidebar,
        toolbar: enToolbar,
        admin: enAdmin,
        student: enStudent,
        corporate: enCorporate,
        courseGroups: enCourseGroups,
        groupAssignments: enGroupAssignments,
    }),
    es: buildMessages({
        common: esCommon,
        auth: esAuth,
        sidebar: esSidebar,
        toolbar: esToolbar,
        admin: esAdmin,
        student: esStudent,
        corporate: esCorporate,
        courseGroups: esCourseGroups,
        groupAssignments: esGroupAssignments,
    }),
};

const savedLocale = getSavedLocale();
applyDocumentLang(savedLocale);

export const i18n = createI18n({
    legacy: true,
    globalInjection: true,
    locale: savedLocale,
    fallbackLocale: 'pt',
    messages,
    missingWarn: false,
    fallbackWarn: false,
});

export function setAppLocale(locale) {
    if (!isSupportedLocale(locale)) return;
    const current = i18n.global.locale;
    if (current && typeof current === 'object' && 'value' in current) {
        current.value = locale;
    } else {
        i18n.global.locale = locale;
    }
    persistLocale(locale);
    applyDocumentLang(locale);
    syncVuetifyLocale(locale);
}

export function tOutside(key, values) {
    return i18n.global.t(key, values);
}

export function resolveI18nLocale(locale) {
    const raw = locale || i18n.global.locale;
    if (raw && typeof raw === 'object' && 'value' in raw) {
        return raw.value;
    }
    return raw;
}

export function getNamespaceMessages(namespace, locale) {
    const current = resolveI18nLocale(locale);
    const bag = messages[current] || messages.pt;
    return bag[namespace] || messages.pt[namespace] || {};
}

export { bindVuetify, getSavedLocale };
export default i18n;
